export const BUILD_VERSION = '72de61aa97cfa0720cc5f899dab52c7a8961657a';
